import { isBrowser } from './environment'

let http = null

export const ERROR_NO_HTTP_HANDLER = 'NO HTTP handler found'

export function importHTTP(handler) {
  http = handler
}

export default function HTTP(...args) {
  return new Promise((resolve, reject) => {
    if (typeof http === 'function') {
      http(...args)
        .then(resolve)
        .catch(reject)
    } else {
      reject(ERROR_NO_HTTP_HANDLER)
    }
  })
}

export function sendBeacon(url, data) {
  if (isBrowser() && navigator.sendBeacon) {
    navigator.sendBeacon(url, data)
  } else {
    HTTP({ url, data }, false)
  }
}
